import type { ReactNode, CSSProperties } from 'react';

interface Props {
  children: ReactNode;
  pad?: number;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

export function Card({ children, pad = 18, className, style, onClick }: Props) {
  return (
    <div
      className={['qb-card', onClick ? 'cursor-pointer' : '', className].filter(Boolean).join(' ')}
      style={{ padding: pad, ...style }}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
